import type { CSSProperties, InterpolationFunction } from 'styled-components';

/*
 * Helper to easier add frequently used css properties as properties to a component.
 * For example to add width and height properties:
 *
 * export default styled(MyComponent)<SizeProps>(StyleFromProps);
 */

export type PositionProps = Pick<
	CSSProperties,
	'position' | 'left' | 'right' | 'top' | 'bottom'
>;
export type SizeProps = Pick<CSSProperties, 'width' | 'height'>;
export type PositionAndSizeProps = PositionProps & SizeProps;

export const PositionAndSizeFromProps: InterpolationFunction<PositionAndSizeProps> =
	(props: PositionAndSizeProps) => ({
		position: props.position,
		left: props.left,
		right: props.right,
		top: props.top,
		bottom: props.bottom,
		width: props.width,
		height: props.height
	});

export const PositionFromProps: InterpolationFunction<PositionProps> = (
	props: PositionProps
) => ({
	position: props.position,
	left: props.left,
	right: props.right,
	top: props.top,
	bottom: props.bottom
});

export const SizeFromProps: InterpolationFunction<SizeProps> = (
	props: SizeProps
) => ({
	width: props.width,
	height: props.height
});
